interface PDFHeaderDisplayProps {
  topLeftText?: string[];
  bannerImageUrl?: string;
  bannerImageScale?: number;
  bannerImageAlignment?: "left" | "center" | "right";
}

export function PDFHeaderDisplay({ topLeftText, bannerImageUrl, bannerImageScale, bannerImageAlignment }: PDFHeaderDisplayProps) {
  if (topLeftText && topLeftText.length > 0) {
    return (
      <div className="flex w-full flex-row items-start justify-between bg-white px-6 py-6">
        {/* Top Left Text */}
        <div className="flex-1 pr-4">
          {topLeftText.map((line, index) => (
            <p key={index} className={`text-xs leading-relaxed ${index === 0 ? "font-bold" : ""}`}>
              {line}
            </p>
          ))}
        </div>
        {/* Logo on the right */}
        {bannerImageUrl && (
          <div className="shrink-0 pl-4">
            <img
              src={bannerImageUrl}
              alt="Company Logo"
              className="h-auto max-h-32 object-contain"
              style={{
                transform: `scale(${bannerImageScale || 1})`,
                transformOrigin: "right top",
              }}
            />
          </div>
        )}
      </div>
    );
  }

  /* Banner Image (fallback when topLeftText doesn't exist) */
  if (bannerImageUrl) {
    return (
      <div
        className={`relative flex w-full items-center overflow-hidden bg-white ${
          bannerImageAlignment === "left" ? "justify-start pl-6" : bannerImageAlignment === "right" ? "justify-end" : "justify-center"
        }`}
        style={{
          height: `${144 * (bannerImageScale || 1)}px`, // 144px = h-36, scaled
        }}
      >
        <img
          src={bannerImageUrl}
          alt="Company Banner"
          className="h-full object-contain"
          style={{
            transform: `scale(${bannerImageScale || 1})`,
            transformOrigin: bannerImageAlignment === "left" ? "left center" : bannerImageAlignment === "right" ? "right center" : "center",
          }}
        />
      </div>
    );
  }

  return null;
}
